<template>
  <div id="singleStockInquiry">
    <div class="invoicingHead">
      <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a @click="jumpTT('/invoicing/stockInquiry')" href="javascript:;">库存查询</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>商品库存</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="searchGroup">
      <div class="singleGoods">
        <div>
          <img v-if="list.goodsImage" :src="list.goodsImage" class="img" />
          <img v-else src="@/assets/icon/defaultPic.png" class="img" />
        </div>
        <div class="flex-column-around pl20">
          <div>{{ list.goodsName }}</div>
          <div class="text-color">规格：{{ list.valueContent }}</div>
          <!-- <div class="text-color">库存总额：{{list.totalStockPrice}}</div> -->
          <div class="text-color">库存：{{ list.qrcTotalStockCount }}</div>
          <div class="text-color">仓库：{{ list.repositoryName }}</div>
        </div>
      </div>
      <div class="stockInfo">库存信息</div>
      <div class="stockInfos">
        <el-form ref="form" :model="form" label-width="100px">
          <!-- <el-form-item label="可用库存：">{{list.qrcTotalStockCount}}</el-form-item> -->
          <el-form-item label="当前存货："
            >{{ list.qrcTotalStockCount
            }}<span v-if="list.isInfiniteStock == 0">{{
              list.goodsUnit
            }}</span></el-form-item
          >
          <el-form-item label="初期库存量："
            >{{ list.beginStockNum
            }}<span v-if="list.isInfiniteStock == 0">{{
              list.goodsUnit
            }}</span></el-form-item
          >
          <el-form-item label="出库量："
            >{{ list.outputNum }}{{ list.goodsUnit }}</el-form-item
          >
          <el-form-item label="入库量："
            >{{ list.inputNum }}{{ list.goodsUnit }}</el-form-item
          >
          <el-form-item label="待出库量："
            >{{ list.preOutputNum }}{{ list.goodsUnit }}</el-form-item
          >
          <el-form-item label="待入库量："
            >{{ list.preInputNum }}{{ list.goodsUnit }}</el-form-item
          >
          <el-form-item label="零售价："
            >￥{{ list.retailPrice ? list.retailPrice : 0 }}</el-form-item
          >
          <el-form-item label="原价："
            >￥{{ list.costPrice ? list.costPrice : 0 }}</el-form-item
          >
          <el-form-item label="进货价："
            >￥{{ list.takePrice ? list.takePrice : 0 }}</el-form-item
          >
          <el-form-item label="会员价："
            >￥{{ list.memberPrice ? list.memberPrice : 0 }}</el-form-item
          >
          <el-form-item label="库存总额："
            >￥{{ list.totalStockPrice ? list.totalStockPrice : 0 }}</el-form-item
          >
          <el-form-item label="零售价总额："
            >￥{{
              list.totalRetailPrice ? list.totalRetailPrice.toFixed(2) : 0
            }}</el-form-item
          >
          <el-form-item>
            <el-button type="primary" @click="stockFlow">库存流水</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { singleQueryGoods, repositoryFlowList } from "../api";
export default {
  data() {
    return {
      arr: {},
      list: {},
      form: {},
    };
  },
  created() {
    this.arr = JSON.parse(localStorage.getItem("arr") || "[]");
    console.log(this.arr);
    this.getSingleQueryGoods();
  },
  methods: {
    //跳转
    jumpTT(adress, message) {
      this.$router.push({ path: adress, query: { docId: message } });
    },
    getSingleQueryGoods() {
      singleQueryGoods({
        isManager: 1,
        pageNo: 1,
        row: 9999,
        repositoryId: this.arr.repositoryId,
        goodsId: this.arr.goodsId,
        productId: this.arr.productId,
      }).then((res) => {
        if (res.code == 1) {
          this.list = res.data;
          if (this.list.isInfiniteStock == 1) {
            this.list.qrcTotalStockCount = "无限库存";
          }
          if (this.list.beginIsInfiniteStock == 1) {
            this.list.beginStockNum = "无限库存";
          }
          if (this.list.beginIsInfiniteStock == 0) {
            if (!this.list.beginStockNum) {
              this.list.beginStockNum = 0;
            }
          }
          localStorage.setItem("list", JSON.stringify(this.list));
        }
      });
    },
    stockFlow() {
      this.$router.push("/invoicing/stockFlowList");
    },
  },
};
</script>

<style scoped>
.searchGroup {
  position: absolute;
  top: 100px;
  box-sizing: border-box;
}
.singleGoods {
  width: calc(100vw - 250px);
  height: 200px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.stockInfo {
  width: calc(100vw - 250px);
  height: 36px;
  background: rgba(248, 248, 249, 1);
  margin-top: 20px;
  padding-top: 8px;
  padding-left: 20px;
  box-sizing: border-box;
}
.stockInfos {
  padding: 20px;
}
.pl20 {
  padding-left: 20px;
  box-sizing: border-box;
}
.flex-column-around {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.img {
  width: 185px;
  height: 175px;
  border-radius: 5px;
}
.text-color {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}
</style>
<style></style>
